"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_1 = require("../configs");
class ReclaimSDK {
    /**
     * Initializes the ReclaimSDK with the provided application ID.
     * @param {string} _appId The application ID.
     */
    constructor(_appId) {
        /**
         * Generates a session link for a user to submit proofs.
         * @param userId The user ID.
         * @param onProofSubmission The callback function to be called when the proof submission is verified.
         * @returns An object containing the status, session ID, link, and onVerified promise.
         *          The onSubmission promise resolves when the proof submission is verified and contains the proof details.
         */
        this.generateSession = async ({ userId, onProofSubmissionSuccess, onError }) => {
            const END_TIME = Date.now() + 5 * 60 * 1000;
            try {
                const response = await fetch(`${configs_1.BACKEND_URL}/request-proofs`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        appId: this.appId,
                        userId: userId,
                    })
                });
                const sessionData = await response.json();
                const pollProofSubmissionStatus = async (sessionId) => {
                    try {
                        const response = await fetch(`${configs_1.BACKEND_URL}/get/proof-submission-status/${sessionId}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });
                        if (response.ok) {
                            const proofSubmissionData = await response.json();
                            if (proofSubmissionData.isProofSubmitted) {
                                clearInterval(interval); // Stop polling
                                onProofSubmissionSuccess(); // Call the provided callback
                            }
                            else if (!proofSubmissionData.isSuccess) {
                                clearInterval(interval); // Stop polling
                                onError(new Error(`Proof submission failed ${proofSubmissionData.message}`));
                            }
                        }
                        else {
                            clearInterval(interval); // Stop polling
                            onError(new Error('Failed to check proof submission status'));
                        }
                        // Add polling timeout
                        if (Date.now() > END_TIME) {
                            clearInterval(interval); // Stop polling
                            onError(new Error(`Timeout for session ${sessionId}`));
                        }
                    }
                    catch (error) {
                        clearInterval(interval); // Stop polling
                        throw error;
                    }
                };
                const interval = setInterval(pollProofSubmissionStatus, 4000, sessionData.session.sessionId);
                if (sessionData.isSuccess) {
                    return { sessionId: sessionData.session.sessionId, link: sessionData.verificationUrl };
                }
                else {
                    return { link: '', sessionId: '' };
                }
            }
            catch (e) {
                console.log('ERROR:', e);
            }
        };
        /**
         * Retrieves the proofs submitted for a session.
         * @param sessionId The session ID.
         * @returns An object containing the status and an array of proofs.
         */
        this.getProofs = async (sessionId) => {
            try {
                const response = await fetch(`${configs_1.BACKEND_URL}/get/proof-submission-status/${sessionId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                if (data.isSuccess) {
                    return { status: 'success', proofs: data.session.proofs };
                }
                else {
                    return { status: 'failed', proofs: [] };
                }
            }
            catch (e) {
                console.log('ERROR:', e);
            }
        };
        this.appId = _appId;
    }
}
exports.default = ReclaimSDK;
